import { useLanguage } from "../../i18n/LanguageContext";

const GALLERY_IMAGES = [
  "/images/gallery-groundstaff.jpg",
  "/images/gallery-steward.jpg",
  "/images/gallery-volunteers.jpg",
  "/images/gallery-crew.jpg",
  "/images/gallery-media.jpg",
  "/images/gallery-medical.jpg",
];

export const Gallery = () => {
  const { t } = useLanguage();
  const captions = t.gallery.captions;
  return (
    <section className="marquee-paused relative overflow-hidden border-y border-kn-navy/10 bg-white py-12" data-testid="workforce-gallery">
      <div className="mx-auto mb-9 max-w-7xl px-6 lg:px-10">
        <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-kn-navy/45" data-testid="gallery-eyebrow">
          {t.gallery.eyebrow}
        </p>
      </div>
      <div className="gallery-track flex w-max animate-gallery items-stretch gap-4">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-stretch gap-4 pr-4" aria-hidden={half === 1}>
            {GALLERY_IMAGES.map((src, i) => (
              <figure
                key={`${half}-${i}`}
                className="group relative h-52 w-72 shrink-0 overflow-hidden rounded-xl lg:h-60 lg:w-80"
                data-testid={half === 0 ? `gallery-item-${i}` : undefined}
              >
                <img
                  src={src}
                  alt={captions[i]}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-kn-navy/80 via-kn-navy/15 to-transparent" />
                <figcaption className="absolute bottom-4 left-5 font-mono text-[10px] tracking-[0.24em] uppercase text-white/85">
                  {captions[i]}
                </figcaption>
              </figure>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
